import React, { useEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

// 스타일 컴포넌트 정의 (반응형 포함)
const Container = styled.div``;

const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 1200px; // 최대 너비 설정
`;

const Header = styled.header`
  background-color: #354f52;
  padding: 20px;
`;

const Logo = styled.img`
  height: 100px;
  @media (max-width: 768px) {
    height: 80px;
  }
`;

const MainContent = styled.section`
  background-color: #354f52;
  color: white;
  height: 100vh;
  text-align: center;
  @media (max-width: 767px) {
    padding-left: 20px;
    padding-right: 20px;
    height: 700px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    padding-left: 20px;
    padding-right: 20px;
    height: 700px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 90px; // 간격 늘림

  @media (max-width: 767px) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ContentText = styled.div`
  max-width: 500px;
  text-align: left;

  @media (min-width: 768px) {
  }

  h1 {
    font-size: 4em;

    @media (min-width: 768px) {
      font-size: 7em;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      font-size: 5em;
    }
    line-height: 1.2; // 줄간 간격 조정
    margin: 0 0 0 0; // 간격 줄임
  }

  p {
    font-size: 1.3em;
    font-weight: 300;
    @media (min-width: 768px) {
      font-size: 1.9em;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      font-size: 1.9em;
    }
    margin-top: 30px;
  }
`;

const ContentImage = styled.img`
  // max-width: 100%;
  // height: auto;

  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 768px) {
    max-width: 600px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 350px;
  }
`;

const CallToAction = styled.div`
  color: white;
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 1.7em;
  letter-spacing: 0.1em;
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 1.5em;
  }
  @media (max-width: 767px) {
    font-size: 1.2em;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    // 태블릿 화면 크기에 대한 추가 스타일
  }
`;

const StoreImage = styled.img`
  max-width: 250px;
  height: auto;

  @media (min-width: 768px) {
    max-width: 300px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 250px;
  }
`;

const ScrollIndicator = styled.div`
  font-size: 1.2em;
  margin-top: 20px;
  text-align: right; // 텍스트를 우측 정렬
  letter-spacing: 0.1em; // 글자 간 간격 넓히기

  @media (max-width: 767px) {
    margin-top: 40px;
    font-size: 1em;
  }
`;

const SecondContent = styled.section`
  background-color: #e9edc9;
  color: #354f52;
  text-align: center;
  padding: 150px 20px;
  height: 1500px;
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-left: 20px;
    padding-right: 20px;
    height: 1300px;
  }
`;

const GiftCardTitle = styled.div`
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 3em;
  letter-spacing: 0.1em;

  @media (max-width: 767px) {
    font-size: 2em;
  }
`;

const CategoryTitle = styled.h3`
  grid-column: 1 / -1;
  text-align: left;
  font-size: 1.5em;
  margin-top: 20px;
  margin-bottom: 0px;
  position: relative;
  padding-left: 10px;

  &::before {
    content: "▪"; // 네모 모양의 특수문자
    color: #354f52; // 색상 설정
    font-size: 2em; // 크기 설정
    position: absolute;
    left: -25px; // 타이틀 왼쪽에 위치
    top: 50%;
    transform: translateY(-50%);
  }

  @media (max-width: 767px) {
    margin-left: 10px;
  }
`;

const GiftCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px 0px;
  align-items: center; // 세로 중앙 정렬
  justify-content: center; // 전체 중앙 정렬
  margin-top: 100px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    // 태블릿 화면 크기에 대한 추가 스타일
  }
`;

const GiftCardImage = styled.img`
  width: 80%;
  height: auto;
`;

const Footer = styled.footer`
  background-color: #354f52;
  color: white;
  text-align: center;
  padding: 20px;
`;

function App() {

  useEffect(() => {
    const handleRedirect = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes("android")) {
        window.location.href = "https://naver.com"; // 안드로이드일 경우
      } else {
        window.location.href = "https://google.com"; // 그 외의 경우
      }
    };

    // '/dream/install' 경로에서 리다이렉트 처리
    if (window.location.pathname === "/dream/install") {
      handleRedirect();
    }
  }, []);

  return (
    <Container>
      <Helmet>
        <title>세상시 - 상품권 시세 비교</title>
        <meta name="description" content="대한민국 1등 상품권 시세 비교 어플" />
        <meta name="keywords" content="상품권, 시세 비교, 롯데백화점상품권" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="세상시 - 상품권 시세 비교" />
        <meta
          property="og:description"
          content="대한민국 1등 상품권 시세 비교 어플로 백화점 상품권, 호텔 상품권, 마트 상품권, 주유 상품권, 기타 상품권 등의 시세를 확인할 수 있습니다."
        />
        <meta
          name="keywords"
          content="상품권시세,상품권싸게사는법,백화점상품권,마트상품권,호텔상품권,주유상품권"
        />
        <meta property="og:image" content="%PUBLIC_URL%/logo.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://giftcard-price.netlify.app/" />
        <meta property="og:locale" content="ko_KR" />
        <meta
          name="google-site-verification"
          content="KKZXBdye8CJlIqyu-o9ex9Wjpbj0yBv0MAzJ0npWaJA"
        />
        <meta
          name="naver-site-verification"
          content="36cf9be86330d495271612b2da8f388715fe7843"
        />
      </Helmet>

      <Header>
        <ContentContainer>
          <Logo src="/logo.png" alt="Logo" />
        </ContentContainer>
      </Header>

      <MainContent>
        <ContentContainer>
          <ContentWrapper>
            <ContentText>
              <h1>
                상품권
                <br />살 때<br />팔 때
              </h1>
              <p>대한민국 1등 상품권 시세 비교 어플</p>
            </ContentText>
            <ContentImage src="/content.png" alt="Content" />
          </ContentWrapper>
          <CallToAction>1분 만에 시세 보러가기</CallToAction>
          <Buttons>
            <a href="https://apps.apple.com/app/id6470126917">
              <StoreImage src="appstore.png" alt="App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.sunghee.giftcard">
              <StoreImage src="googleplay.png" alt="Google Play" />
            </a>
          </Buttons>
          <ScrollIndicator>∨ 스크롤</ScrollIndicator>
        </ContentContainer>
      </MainContent>

      <SecondContent>
        <ContentContainer>
          <GiftCardTitle>
            시세 제공
            <br />
            상품권
            <br />
            (19종)
          </GiftCardTitle>
          <GiftCardGrid>
            <CategoryTitle>백화점상품권</CategoryTitle>
            {[...Array(8)].map((_, index) => (
              <GiftCardImage
                src={`/giftcard${index + 1}.png`}
                alt={`Gift Card ${index + 1}`}
                key={`department-${index}`}
              />
            ))}

            <CategoryTitle>호텔상품권</CategoryTitle>
            <GiftCardImage
              src="/giftcard9.png"
              alt="Gift Card 9"
              key="hotel-1"
            />

            <CategoryTitle>마트 상품권</CategoryTitle>
            {[10, 11].map((id) => (
              <GiftCardImage
                src={`/giftcard${id}.png`}
                alt={`Gift Card ${id}`}
                key={`market-${id}`}
              />
            ))}

            <CategoryTitle>기타 상품권</CategoryTitle>
            {[12, 13, 14, 15].map((id) => (
              <GiftCardImage
                src={`/giftcard${id}.png`}
                alt={`Gift Card ${id}`}
                key={`others-${id}`}
              />
            ))}

            <CategoryTitle>주유상품권</CategoryTitle>
            {[16, 17, 18, 19].map((id) => (
              <GiftCardImage
                src={`/giftcard${id}.png`}
                alt={`Gift Card ${id}`}
                key={`fuel-${id}`}
              />
            ))}
          </GiftCardGrid>
        </ContentContainer>
      </SecondContent>

      <Footer>
        <hr />© 2023 Sunghee Lee. All rights reserved.
      </Footer>
    </Container>
  );
}

export default App;
